export default __webpack_public_path__ + "static/media/single-6.e6e0a0fb.jpg";